export default "__VITE_ASSET__DAaUm6NK__"